(function () {
  // import
  // $
  // isset
  // tv_keydown_override
  // tv_left
  // tv_right
  // tv_back
  // showSelectionIndicator
  // navigate
  // tv_keys
  // renderPageOnTheStructv2
  // PreloadMedia
  // event_link
  // gallery

  function Gallery(container) {
    var self = this;

    self.fullScreen = parseInt(container.dataset.fullScreen);
    self.isFullscreenMode = false;

    self.show = function (that) {
      self.isFullscreenMode = false;
      self.stopAutoSlide();
      self.img = that;
      self.container = $(that).closest('.page');
      var img = new Image();
      img.src = $(that).attr('src');

      img.onload = function () {
        $('#tv_cur').hide();
        document.body.classList.add('gallery-opened');
        self.list = that.parentNode.parentNode.querySelectorAll('img');
        self.currentIndex = Array.prototype.indexOf.call(self.list, that);
        self.renderWrap();
        $('.gallery_wrap_img img').remove();
        self.wrap.appendChild(this);

        self._resize.call(this);

        hideOverlay();

        $('.gallery_subContainer').css('display', 'block');
        self.wrap.style.marginTop = -(self.wrap.clientHeight / 2) + 'px';
        self.wrap.style.marginLeft = -(self.wrap.clientWidth / 2) + 'px';

        tv_keydown_override = self._server_keydown;
        if (isset('config.gallery.isSlideShow', false)) {
          var timeout = isset('config.gallery.timeout', 1000);
          self.renderProgressBar();
          self.startAutoSlide(timeout);
        }
      };
    };
    self.left = function () {
      tv_left();
      if (self.isFullscreenMode) return false;
      self.stopAutoSlide();
      var newIndex = (self.currentIndex - 1 + self.list.length) % self.list.length;
      var newImg = self.list[newIndex];
      self.show(newImg);
      self.currentIndex = newIndex;

      if (isset('config.gallery.isSlideShow', false)) {
        var timeout = isset('config.gallery.timeout', 1000);
        self.startAutoSlide(timeout);
      }
    };
    self.right = function () {
      tv_right();
      if (self.isFullscreenMode) return false;
      self.stopAutoSlide();
      var newIndex = (self.currentIndex + 1) % self.list.length;
      var newImg = self.list[newIndex];
      self.show(newImg);
      self.currentIndex = newIndex;
      if (isset('config.gallery.isSlideShow', false)) {
        var timeout = isset('config.gallery.timeout', 1000);
        self.startAutoSlide(timeout);
      }
    };
    self.close = function () {
      self.stopAutoSlide();
      self.isFullscreenMode = true;
      tv_keydown_override = null;

      if (self.fullScreen) {
        self.wrap.classList.remove('fullscreen');
        self.fullScreen = 0;
        self.container.attr('data-full-screen', '0');
      }

      showOverlay();

      var $gallerySubContainer = $('.gallery_subContainer'),
        id = $gallerySubContainer.attr('id');
      $gallerySubContainer.remove();

      self.removeProgressBar();

      tv_back();
      document.body.classList.remove('gallery-opened');
      showSelectionIndicator();
    };
    self.hidden = function () {
      navigate('#' + $('.gallery_subContainer').attr('id'));
    };
    self.renderWrap = function () {
      if ($('.gallery_subContainer').length) {
        $('.gallery_subContainer').remove();
      }
      self.subContainer = document.createElement('div');
      self.subContainer.classList.add('gallery_subContainer');
      self.subContainer.setAttribute('data-qa','imageToFullScreen');
      self.subContainer.id = self.container.attr('id');

      self.wrap = document.createElement('div');
      self.wrap.classList.add('gallery_wrap_img');
      if (self.fullScreen) {
        self.wrap.classList.add('fullscreen');
      }

      self.btn = document.createElement('div');
      self.btn.classList.add('btn');
      self.btn.setAttribute('onvclick', 'gallery.close()');

      self.wrap.appendChild(self.btn);
      self.subContainer.appendChild(self.wrap);
      self.container.append(self.subContainer);
      self.wrap.setAttribute('data-qa', 'slide-' + self.currentIndex);
    };
    self._resize = function () {
      var margin = self.fullScreen ? 0 : 20;
      var max_width = 1280 - margin;
      var max_height = 720 - margin;

      var originalWidth = this.width;
      var originalHeight = this.height;
      var ratio = originalWidth / originalHeight;

      var targetWidth = max_width;
      var targetHeight = targetWidth / ratio;

      if (targetHeight > max_height) {
        targetHeight = max_height;
        targetWidth = targetHeight * ratio;
      }

      self.wrap.style.width = targetWidth + margin + 'px';
      self.wrap.style.height = targetHeight + margin + 'px';
      this.style.width = targetWidth + 'px';
      this.style.height = targetHeight + 'px';
    };
    self._server_keydown = function (e) {
      if (!e) {
        e = event;
      }
      var code = e.keyCode ? e.keyCode : e.which;

      switch (code) {
        case tv_keys.ENTER:
          self.close();
          break;
        case tv_keys.LEFT:
          self.left();
          break;
        case tv_keys.RIGHT:
          self.right();
          break;
        case tv_keys.PORTAL:
        case tv_keys.GUIDE:
        case tv_keys.Q_MENU:
        case tv_keys.MENU:
        case tv_keys.HOME:
          self.close();
          navigate('#menu');
          break;
        case tv_keys.EXIT:
        case tv_keys.BACK:
          self.close();
          break;
      }
    };

    self.startAutoSlide = function (interval) {
      var startTime = null;

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var elapsed = timestamp - startTime;
        var progress = Math.min(elapsed / interval, 1);
        self.progressBar.style.width = progress * 100 + '%';

        if (elapsed >= interval) {
          if (self.isFullscreenMode || !document.contains(self.wrap)) return;
          self.right();
          startTime = null;
        }
        self.autoSlideRaf = requestAnimationFrame(step);
      }

      if (self.autoSlideRaf) cancelAnimationFrame(self.autoSlideRaf);
      self.autoSlideRaf = requestAnimationFrame(step);
    };

    self.stopAutoSlide = function () {
      if (self.autoSlideRaf) {
        cancelAnimationFrame(self.autoSlideRaf);
        self.autoSlideRaf = null;
      }
    };

    self.removeProgressBar = function () {
      if (self.progressContainer && self.progressContainer.parentNode) {
        self.progressContainer.parentNode.removeChild(self.progressContainer);
        self.progressContainer = null;
        self.progressBar = null;
      }
    };

    self.renderProgressBar = function () {
      if (self.progressContainer) return;
      self.progressContainer = document.createElement('div');
      self.progressContainer.classList.add('gallery-progress-container');

      self.progressBar = document.createElement('div');
      self.progressBar.classList.add('gallery-progress-bar');

      self.progressContainer.appendChild(self.progressBar);
      document.body.appendChild(self.progressContainer);
    };
  }

  function gallery_test() {
    window.getJson('modules/Tests/gallery_test.json').then(function (d) {
      renderPageOnTheStructv2(d.id, d, 'gallery', 'gallery_page');
      var page_id = '#' + d.id;
      new PreloadMedia(page_id).done(function () {
        navigate(page_id);
        $('#' + d.id + ' .gallery_container IMG').on(event_link, function () {
          gallery = new Gallery(this.closest('.gallery_container'));
          gallery.show(this);
        });
      });
    });
  }

  window.Gallery = Gallery;
  window.gallery_test = gallery_test;
})();
